import { useState, useEffect } from 'react';

const useUpazillaData = (id) => {
  const [upazilla, setUpaZilla] = useState([]);
  const [loadingUpazilla, setLoading] = useState(true);
  const [errorUpazilla, setError] = useState(null);

  useEffect(() => {
    const fetchUpazilla = async () => {
      try {
        const response = await fetch(`https://bdapi.vercel.app/api/v.1/upazilla/${id}`);
        if (!response.ok) {
          throw new Error("Failed to fetch ");
        }
        const data = await response.json();
        setUpaZilla(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUpazilla();
  }, [id]);

  return { upazilla, loadingUpazilla, errorUpazilla };
};

export default useUpazillaData;
